// 3rd party imports
import * as React from 'react';

// bernie
import { DialogRoute, closeDialog } from 'bernie-core';
import { Layer } from 'bernie-view';

// shared-ui
import { ILocalization } from '@shared-ui/localization-context';

// ui
import { UitkDialog, UitkDialogFooter } from 'uitk-react-dialog';
import { PzFormInfoAccount, PzFormInfoEligibility, PzFormInfoList } from './pz-info';
import { useHistory, useLocation } from 'react-router';

export interface PzFormInfoDialogProps {
  dialogId: string;
  infoEntry: string;
  programName?: string;
  rules: object;
  l10n?: ILocalization;
}

export const PzFormInfoDialog: React.FunctionComponent<PzFormInfoDialogProps> = ({
  dialogId,
  infoEntry,
  programName,
  rules,
  l10n,
}) => {
  const history = useHistory();
  const location = useLocation();

  const onDismiss = () => {
    closeDialog({ history, location, key: dialogId });
  };

  let dialogContent;

  switch (infoEntry) {
    case 'eligibility':
      dialogContent = programName && <PzFormInfoEligibility programName={programName} />;
      break;

    case 'username':
    case 'password':
      dialogContent = <PzFormInfoList titleName={`pz.signup.info.${infoEntry}.title`} rules={rules[infoEntry]} />;
      break;

    case 'accountname':
      dialogContent = <PzFormInfoAccount rules={rules['accountname']} />;
      break;

    default:
      break;
  }

  return (
    <>
      <DialogRoute id={dialogId}>
        <Layer id="dialogPzInfo" onDismiss={onDismiss}>
          <UitkDialog returnFocusOnClose={true}>
            {dialogContent}
            <UitkDialogFooter
              key="UitkDialogFooter"
              stacked={true}
              buttonOne={{
                onClick: onDismiss,
                text: l10n.formatText('common.dialog.close'),
                type: 'tertiary',
              }}
            />
          </UitkDialog>
        </Layer>
      </DialogRoute>
    </>
  );
};
